export const AGORA_APP_ID = 'b63e9546e042410dbc7158d58d766341'



// WEBPACK FOOTER //
// ./src/agora.config.js